import React, {Fragment, useState} from 'react';

const EditTodo = ({todo}) => {

  const [description, setDescription] = useState(todo.description);

  // edit description function

  const updateDescription = async(e) => {
    e.preventDefault();
    try {

      const body = {description}
      const response = await fetch(`/api/todos/${todo.todo_id}`, {
        method: "PUT",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(body)
      })
      window.location = "/";

    } catch (error) {
      console.error(error.message)
    }
  }

  return (
    <Fragment>
      <button type="button" className="btn btn-warning" data-toggle="modal" data-target={`#id${todo.todo_id}`}>
        Edit
      </button>

      <div className="modal" id={`id${todo.todo_id}`} onClick={() => setDescription(todo.description)}>
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h4 className="modal-title">Edit Todo</h4>
              <button type="button" className="close" data-dismiss="modal" onClick={() => setDescription(todo.description)}>&times;</button>
            </div>
            <div className="modal-body">
              <input
                value={description}
                type="text"
                className="form-control"
                onChange={e => setDescription(e.target.value)}
              />
            </div>

            <div className="modal-footer">
              <button onClick={e=> updateDescription(e)} type="button" className="btn btn-warning" data-dismiss="modal">Edit</button>
              <button onClick={() => setDescription(todo.description)} type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

export default EditTodo;